import React from "react";
import "./ActionLink.css";

export type ActionLinkProps = {
  disabled?: boolean;
  variant?: "primary" | "secondary" | "tertiary";
  size?: "sm" | "md" | "lg";
  className?: string;
//   isLoading: boolean;
  label?: string;
  value?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children?: React.ReactNode;
};

export const ActionLink = ({
    disabled = false,
    variant = "primary",
    size = "md",
    className,
    label,
    leftIcon,
    rightIcon,
    children,
    ...props
}: ActionLinkProps & React.ComponentPropsWithoutRef<"div">) => {

    const getVariantClass = () => {
        switch (variant) {
            case "primary":
                return "ds2-action-link-primary";
            case "secondary":
                return "ds2-action-link-secondary";
            case "tertiary":
                return "ds2-action-link-tertiary";
            default:
                return "ds2-action-link-primary";
        }
    }

    const getSizeStyles = () => {

        switch (size) {
            case "sm":
                return {height: "24px", minWidth: "100px", fontSize: ".85rem"};
            case "md":
                return {height: "32px", minWidth: "100px", fontSize: "1rem"};
            case "lg":
                return {height: "40px", minWidth: "120px", fontSize: "1.25rem"};
            default:
                return {height: "40px", minWidth: "100px", fontSize: ".85rem"};
        }
    }

    const getInnerSizeStyles = () => {
    
        switch (size) {
            case "sm":
                return {padding: "0px", gap: "2px", fontSize: ".85rem"};
            case "md":
            case "lg":
            default:
                return {padding: "8px 12px", gap: "4px", fontSize: "1rem"};
        }
    }
    
    return (
        <div 
            className={getVariantClass() + " " + className}
            style={{
                ...getSizeStyles(),
                ...getInnerSizeStyles(),
            }}
            {...props} 
        >     
            {leftIcon && leftIcon}
            {label && label}
            {children && children}
            {rightIcon && rightIcon}
        </div> 
        
    );
}  